module.exports = __webpack_public_path__ + "img/5建立超胞20220420_100840.1b4b8839.gif";